export const createRetryablePreloader = <T>(importer: () => Promise<T>) => {
  let loadedModule: Promise<T> | undefined;

  return (): Promise<T> => {
    if (!loadedModule) {
      loadedModule = importer().catch((error) => {
        loadedModule = undefined;
        throw error;
      });
    }

    return loadedModule;
  };
};

export const loadOfflineTransactionSummary = createRetryablePreloader(
  () => import('../pages/transactions/summary')
);
